import { zodResolver } from '@hookform/resolvers/zod';
import type { PropsWithChildren } from '@shared/utils';
import { FormProvider, useForm } from 'react-hook-form';

import {
  ExamCenterProctorDetailsSchema,
  type ExamCenterProctorDetailsFormInput,
} from './exam-center-proctor-details-form-schema';

interface ExamCenterProctorDetailsFormProviderProps extends PropsWithChildren {
  initialValues: ExamCenterProctorDetailsFormInput;
}

export default function ExamCenterProctorDetailsFormProvider(
  props: Readonly<ExamCenterProctorDetailsFormProviderProps>,
) {
  const { children, initialValues } = props;

  const formContext = useForm<ExamCenterProctorDetailsFormInput>({
    resolver: zodResolver(ExamCenterProctorDetailsSchema),
    defaultValues: initialValues,
  });

  return <FormProvider {...formContext}>{children}</FormProvider>;
}
